/**
 * Check whether there is a device and subscription in the cart.
 *
 * @param productsData An array of cart product data.
 * @returns Object with a boolean indicating whether there is a subscription plan and device in the cart.
 */
export const getCartOptions = (productsData: ICartProduct[]) => {
  // Check if there is a subscription plan in the cart
  const hasPlan = productsData.some(({ type }) => type === "plan");

  // Check if there is a device in a cart
  const hasDevice = productsData.some(({ type }) => type === "device");

  return { hasPlan, hasDevice };
};
